"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ThumbnailSizes;
(function (ThumbnailSizes) {
    ThumbnailSizes["XS"] = "XS";
    ThumbnailSizes["S"] = "S";
    ThumbnailSizes["M"] = "M";
    ThumbnailSizes["L"] = "L";
    ThumbnailSizes["XL"] = "XL";
})(ThumbnailSizes || (ThumbnailSizes = {}));
var Thumbnail = function (_a) {
    var src = _a.src, alt = _a.alt, _b = _a.size, size = _b === void 0 ? ThumbnailSizes.M : _b, _c = _a.fit, fit = _c === void 0 ? 'cover' : _c, _d = _a.padding, padding = _d === void 0 ? 'none' : _d, className = _a.className, onClick = _a.onClick, _e = _a.overlay, overlay = _e === void 0 ? null : _e, props = __rest(_a, ["src", "alt", "size", "fit", "padding", "className", "onClick", "overlay"]);
    var ThumbnailClassNames = classnames_1.default('Thumbnail', sizeClass(size), fitClass(fit), className, {
        'Thumbnail--thin': padding === 'thin',
        'Thumbnail--clickable': !!onClick,
    });
    return (react_1.default.createElement("div", __assign({ className: ThumbnailClassNames, onClick: onClick }, props),
        react_1.default.createElement("img", { src: src, alt: alt }),
        overlay !== null && (react_1.default.createElement("div", { className: "Thumbnail__overlay" }, overlay))));
};
exports.Thumbnail = Thumbnail;
exports.Thumbnail.Sizes = ThumbnailSizes;
exports.Thumbnail.displayName = 'Thumbnail';
function sizeClass(size) {
    return "Thumbnail--" + size;
}
function fitClass(fit) {
    return "Thumbnail--" + fit;
}
//# sourceMappingURL=Thumbnail.js.map